import type { ModuleData } from '#providers'

import { ModuleProvider, useModule } from '#providers'

import type {
	CustomQuestionnaireAnswersPayload,
	CustomQuestionnaireConfigurationDto,
} from '../../api/customQuestionnaire'

interface CustomQuestionnaireConfig {}

export type CustomQuestionnaireModuleData = ModuleData<
	CustomQuestionnaireConfigurationDto,
	CustomQuestionnaireAnswersPayload,
	CustomQuestionnaireConfig
>

export const CustomQuestionnaireModuleProvider: typeof ModuleProvider<CustomQuestionnaireModuleData> =
	ModuleProvider

export const useCustomQuestionnaireModule: typeof useModule<CustomQuestionnaireModuleData> =
	useModule
